import api from './axiosConfig';

export const packagesAPI = {
  get: async () => {
    const response = await api.get('/packages');
    return response.data;
  },
  update: async (config) => {
    const response = await api.put('/packages', config);
    return response.data;
  },
};
